import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import CertificateFilesFetcher from "../../apiTables/CertificateFilesFetcher";

const InsectFilesPage = ({geoIds}) => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <CertificateFilesFetcher geoIds={geoIds}/>
                </div>
            </div>
        </div>
    );
};

export default InsectFilesPage;
